import { gql } from '@apollo/client';

export const ARCHIVE_ACTIVITY = gql`
  mutation archiveActivity($id: ID!) {
    activity: archiveActivity(id: $id) {
      id
    }
  }
`;
